import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
@Component({
  selector: 'app-contact-us-modal',
  templateUrl: './contact-us-modal.component.html',
  styleUrls: ['./contact-us-modal.component.scss']
})
export class ContactUsModalComponent implements OnInit {
  privacyHeader: any;
  privacyMessage: any;
  constructor(
    private dialogRef: MatDialogRef<ContactUsModalComponent>
  ) { }

  ngOnInit() {
    this.privacyHeader = "Contact Us";
  }
}
